// How long ago an open job was started, for the "Older open jobs" list on Installer home
// (NEU-1114). The server decides which jobs are older (a week); this only words the age.
export function startedAgoLabel(startedAt, now = new Date()) {
  const days = Math.floor((now - new Date(startedAt)) / 86400000);
  if (!(days >= 1)) return "Started today";
  return `Started ${days} day${days === 1 ? "" : "s"} ago`;
}
